import React, { useEffect, useState } from "react";
import { Avatar, HStack, IconButton, Link, Popover, Portal, Stack, Text } from "@chakra-ui/react";
import { LuBookCheck, LuDownload, LuLogOut, LuUser, LuUserRoundCog, LuView } from "react-icons/lu";
import { removeToCache } from "../../../utilies/Utility";
import { useAppStore } from "../../../context/store";
import Type from "../../../utilies/Types";
import { Tooltip } from "../../../components/ui/tooltip";

function AccountSettings() {
  const userType = useAppStore((s) => s.userType);
  const userData = useAppStore((s) => s.userData);

  const setIsLoggedIn = useAppStore.getState().setIsLoggedIn;

  const logOut = () => {
    setIsLoggedIn("false");
    removeToCache(Type.STORAGE.USERINFO);
  };

  const [userTypeLocal, setUserTypeLocal] = useState([]);
  useEffect(() => {
    let temp = [];
    for (const key in userType) {
      if ([Type.ROLE.ADMIN, Type.ROLE.ANNOTATOR, Type.ROLE.REVIEWER, Type.ROLE.VIEWER, Type.ROLE.SUPER_ADMIN].includes(userType[key])) {
        temp.push(userType[key]);
      }
    }
    setUserTypeLocal(temp);
  }, []);

  return (
    <Popover.Root positioning={{ placement: "bottom-end" }}>
      <Popover.Trigger asChild>
        <IconButton userSelect="none" boxShadow="lg" bg="Background" rounded={"full"}>
          <Tooltip content="Profile">
            <LuUser color="MenuText" />
          </Tooltip>
        </IconButton>
      </Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <Popover.Arrow />
            <Popover.Body p={2}>
              <HStack mb={3} mt={3} gap={3} justify="space-between" align="start">
                <HStack align="start">
                  <Avatar.Root>
                    <Avatar.Fallback name={userData?.user?.first_name + " " + userData?.user?.last_name} />
                    <Avatar.Image src={userData?.photos} />
                  </Avatar.Root>

                  <Stack gap={0}>
                    <Text fontWeight="semibold" textStyle="md">
                      {userData?.user?.first_name} {userData?.user?.last_name}
                    </Text>

                    <Text textStyle="sm">@{userData?.user?.username}</Text>

                    {userTypeLocal.map((role, index) => (
                      <HStack gap={1} key={index}>
                        {role === Type.ROLE.ADMIN && <LuUserRoundCog />}
                        {role === Type.ROLE.REVIEWER && <LuView />}
                        {role === Type.ROLE.VIEWER && <LuView />}
                        {role === Type.ROLE.ANNOTATOR && <LuBookCheck />}
                        {role === Type.ROLE.SUPER_ADMIN && <LuUserRoundCog />}
                        <Text>{role}</Text>
                      </HStack>
                    ))}
                  </Stack>
                </HStack>

                <IconButton aria-label="Log Out" rounded="full" bg="red.500" onClick={logOut}>
                  <LuLogOut />
                </IconButton>
              </HStack>

              <HStack mt={3}>
                <LuDownload />
                <Link href="https://matrix.gatik.ai/static/horizon_foxglove/gatik.horizon-hdmap-extension.foxe">Download Horizon Extension For Foxglove</Link>
              </HStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}

export default AccountSettings;
